import { RateSheetGeneratorProfileResponse } from 'RtModels';
import { RateSheetGenerationEditor } from 'RtUi/app/AccountManagement/RateSheetGenerator/libs/forms/rateSheetGenerationEditor';
import { RateSheetGeneratorEditor } from 'RtUi/app/AccountManagement/RateSheetGenerator/libs/forms/RateSheetGeneratorEditor';
import { RateSheetGenerationDataGrid } from 'RtUi/app/AccountManagement/RateSheetGenerator/libs/grids/RateSheetGenerationGrid';
import { RateSheetGeneratorDataGrid } from 'RtUi/app/AccountManagement/RateSheetGenerator/libs/grids/RateSheetGeneratorGrid';
import { RateSheetGeneratorRouter } from 'RtUi/app/AccountManagement/RateSheetGenerator/RateSheetGenerator.router';
import { TabbedLayout, TabbedLayoutTab } from 'RtUi/components/ui/TabbedLayout';
import { useTabs } from 'RtUi/components/ui/TabbedLayout/useTabs';

export const RateSheetGeneratorIndexContainer = (): JSX.Element => {
	const [tabs, activeTab, setActiveTab] = useTabs({
		RateSheetGenerations: { header: 'Rate Sheet Generations', isDefault: true },
		RateSheetGenerators: { header: 'Rate Sheet Generation Configurations' },
		CreateRateSheetGeneration: { header: 'Create Rate Sheet', isAction: true },
		CreateRateSheetGenerator: {
			header: 'Create Rate Sheet Configuration',
			isAction: true
		}
	});

	return (
		<TabbedLayout
			router={RateSheetGeneratorRouter}
			activeTab={activeTab.header}
			onTabChange={setActiveTab}
		>
			<TabbedLayoutTab {...tabs.RateSheetGenerations}>
				<RateSheetGenerationDataGrid />
			</TabbedLayoutTab>
			<TabbedLayoutTab {...tabs.RateSheetGenerators}>
				<RateSheetGeneratorDataGrid />
			</TabbedLayoutTab>
			<TabbedLayoutTab {...tabs.CreateRateSheetGeneration}>
				<RateSheetGenerationEditor
					createMode
					rateSheetGeneratorId={0}
					// onSuccess={() => setActiveTab(tabs.RateSheetGenerations.header)}
					// onCancel={() => setActiveTab(tabs.RateSheetGenerations.header)}
				/>
			</TabbedLayoutTab>
			<TabbedLayoutTab {...tabs.CreateRateSheetGenerator}>
				<RateSheetGeneratorEditor
					createMode
					onUpdate={function (
						updatedResource: RateSheetGeneratorProfileResponse
					): void {
						throw new Error('Function not implemented.');
					}} // onSuccess={() => setActiveTab(tabs.SipAgentConfigs.header)}
					// onCancel={() => setActiveTab(tabs.SipAgentConfigs.header)}
				/>
			</TabbedLayoutTab>
		</TabbedLayout>
	);
};

RateSheetGeneratorIndexContainer.displayName =
	'RateSheetGeneratorIndexContainer';

RateSheetGeneratorRouter.setIndexRtUiFunctionalComponent(
	RateSheetGeneratorIndexContainer
);
